import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IAnimStartFeature } from './anim-start-interface';
import { config } from './config';
import { IAnimModel } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { DEFAULT_CLICK_SPID } from '@tencent/slide-sdk-model';
import { PPTEditorStateEnumType } from '@src/slide/domain/ui-model/constant/edit-state-type';

@Feature()
export class AnimStartFeature extends BaseToolbarFeature implements IAnimStartFeature {
    public id = config.id;
    public config = config;
    private selectedAnimList = this.getSelectedAnimManager()?.selectedArray;
    public constructor() {
        super();
    }

    public onClick(menuName: string) {
        if (!this.selectedAnimList?.length) {
            return;
        }
        this.selectedAnimList.forEach((animModel: IAnimModel) => {
            if (!animModel.clickSpid) {
                animModel.clickSpid = DEFAULT_CLICK_SPID;
            }
            this.getSelectionService()?.currentSlide?.modifyAnimation(animModel, { nodeType: menuName });
        });
    }

    public shouldCheck(menuName: string): boolean {
        if (!this.selectedAnimList?.length) return false;
        const [
            {
                props: { nodeType },
            },
        ] = this.selectedAnimList;
        if (this.selectedAnimList.every((animModel: IAnimModel) => animModel.props.nodeType === nodeType)) {
            return menuName === nodeType;
        }

        return false;
    }

    public shouldDisabled(): boolean {
        if (this.getUserPriviledgeService().pptEditorState !== PPTEditorStateEnumType.EDITABLE) return true;
        return !this.selectedAnimList?.length;
    }
}
